module.exports = __webpack_public_path__ + "static/media/developer.82797044.png";